import {useEffect, useState} from "react";


const useUpdateOnlyEffect = (effect, dependencies) => {
  const [firstCall, setFirstCall] = useState(true);

  useEffect(() => {
    if (firstCall) {
      setFirstCall(false);
    } else {
      return effect();
    }
  }, dependencies);
};

export default useUpdateOnlyEffect;
